export default {
	pcs_search_placeholder: '搜尋手機型號',
	pcs_price_starts_from: '目前最低價格：',
	pcs_zero_source_found: '目前沒有符合的網站',
	pcs_one_source_found: '找到 1 個網站出售',
	pcs_multiple_sources_found: '找到 {count} 個網站出售',
	pcs_breadcrumb_home: 'Buyandship',
	pcs_product_prices_tab: '全球格價',
	pcs_product_details_tab: '手機產品',
	pcs_show_order_avail: '顯示有貨',
	pcs_product_last_updated: '最後更新：',
	pcs_product_place_order: '立即下單',
	pcs_product_detail_header: '產品詳情',
	pcs_product_detail_name: '產品名稱',
	pcs_product_detail_description: '描述',
	pcs_product_detail_brand: '品牌',
	pcs_product_detail_category: '類別',

	pcs_filter_button_name: '篩選',
	pcs_filter_clear_all: '清除全部',
	pcs_filter_apply: '套用',
	pcs_singular_result: '結果',
	pcs_plural_result: '結果',
	pcs_filter_brand: '品牌',
	pcs_filter_colours: '顏色',
	pcs_filter_price: '價格',
	pcs_filter_range_options_range1: 'HK$1,000 以下',
	pcs_filter_range_options_range2: 'HK$1,000 - HK$9,000',
	pcs_filter_range_options_range3: 'HK$9,000 以上',
	pcs_filter_source: '網站來源',
	pcs_filter_specifications: '規格',
	pcs_button_wait: '正在打開',
	pcs_button_show_more: '顯示更多',
	pcs_result_price_start_from: '由',
	pcs_result_price_start_end: '起',
	pcs_no_results_found: '目前沒有可供訂購的產品。',
	pcs_no_results_found_for: '0 項搜尋結果:',
	pcs_advise_reset_filter: '請稍後再回來查看或搜尋其他產品。',
	pcs_advise_check_keyword: '目前沒有相關產品資料。你可以嘗試搜尋其他產品。',
	pcs_auto_translated_message: '已開啟自動翻譯。',
	pcs_show_original_language: '顯示原文',
	pcs_hide_original_language: '隱藏原文',
	pcs_you_searched_for: '目前搜尋：',
	pcs_no_order_available: '目前沒有可下訂的產品',
	pcs_404_not_found: '未找到網頁',
	pcs_404_message: '請檢查網址並重試',
	pcs_404_back_to_home: '回到首頁',
}
